import { ClientPostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { PostFeedType } from '@/features/posts/types/postFeed';
import { POST_FEED_TYPE_POST_TYPE } from '@/features/posts/utils/postFeed';

/**
 * Resolves the concrete post type for shared post-form channel values
 * (personal + organization post forms). MARKET is split into Offer / Seeking
 * by the sub-type toggle.
 */
export const resolvePostType = (values: {
  channelType: PostFeedType;
  marketType: ClientPostTypeEnum;
}): ClientPostTypeEnum => {
  if (values.channelType === PostFeedType.MARKET) {
    return values.marketType === ClientPostTypeEnum.Seeking
      ? ClientPostTypeEnum.Seeking
      : ClientPostTypeEnum.Offer;
  }
  return POST_FEED_TYPE_POST_TYPE[values.channelType];
};
